import { Component, OnInit } from '@angular/core';
import { CourseFilterService } from '../_services/course-filter.service';

@Component({
  selector: 'app-view-options',
  templateUrl: './view-options.component.html',
  styleUrls: ['./view-options.component.scss']
})
export class ViewOptionsComponent implements OnInit {

  constructor(public courseFilterService: CourseFilterService) { }

  ngOnInit() {
  }
  public setListDisplay(display: string) {
    this.courseFilterService.courseListDisplayType = display;
    return false;
  }
}
